import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { CaseStudy } from "@/types";

const caseStudies: CaseStudy[] = [
  {
    id: "1",
    image: "https://images.unsplash.com/photo-1556742031-c6961e8560b0?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&h=500",
    category: "E-commerce",
    categoryColor: "bg-blue-600/10 text-blue-600",
    title: "Conversion Rate Optimization",
    description: "How we helped an online retailer increase conversions by 37% through advanced customer journey analytics and A/B testing.",
    roi: "420%",
    link: "#"
  },
  {
    id: "2",
    image: "https://images.unsplash.com/photo-1576670159375-32fb3b60.jpg?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&h=500",
    category: "BioScience",
    categoryColor: "bg-purple-600/10 text-purple-600",
    title: "Predictive Maintenance AI",
    description: "Implementing an AI solution that reduced equipment downtime by 62% for a major biotech manufacturer.",
    roi: "290%",
    link: "#"
  },
  {
    id: "3",
    image: "https://images.unsplash.com/photo-1552581234-26160f608093?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&h=500",
    category: "DTC",
    categoryColor: "bg-emerald-600/10 text-emerald-600",
    title: "Customer Data Platform",
    description: "Building a comprehensive CDP that unified customer data across 12 touchpoints for a D2C brand.",
    roi: "380%",
    link: "#"
  }
];

const CaseStudies = () => {
  return (
    <section id="case-studies" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="section-title">Case Studies</h2>
          <p className="section-subtitle">
            See how we've helped organizations achieve remarkable results
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {caseStudies.map((study) => (
            <div key={study.id} className="bg-white rounded-lg shadow-lg overflow-hidden">
              <img 
                src={study.image} 
                alt={study.title} 
                className="w-full h-48 object-cover" 
                width="800" 
                height="500"
              />
              <div className="p-6">
                <span className={`inline-block px-3 py-1 ${study.categoryColor} text-sm font-medium rounded-full mb-4`}>
                  {study.category}
                </span>
                <h3 className="text-xl font-bold mb-2">{study.title}</h3>
                <p className="text-gray-600 mb-4">
                  {study.description}
                </p>
                <div className="flex justify-between items-center">
                  <span className="text-sm text-gray-500">ROI: {study.roi}</span>
                  <a href={study.link} className="text-blue-600 font-medium inline-flex items-center">
                    Read case study <ArrowRight className="ml-2 h-4 w-4" />
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="text-center mt-12">
          <Button variant="outline" className="border-blue-600 text-blue-600 hover:bg-blue-600/5">
            View All Case Studies
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CaseStudies;
